import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { bookAppointmentWhereStepScreenEvent } from '../../data-layer/actions.js';
import { useAppointmentContext } from '../../pages/BookAppointment/context/AppointmentContext.js';
import { useRoutingContext } from '../../pages/BookAppointment/context/RoutingContext/context.js';
import AppointmentLocation$1 from './AppointmentLocation.js';
import useBookAppointmentTypeWithUrlParam from '../../pages/BookAppointment/hooks/use-book-appointment-type-with-url-param.js';

const AppointmentLocationContainer = (props)=>{
    const [{ setStore , setType , setTimeSlot  }, { store , type , timeSlot  }] = useAppointmentContext();
    const [, { queryParams  }] = useRoutingContext();
    /** Refetch appointment type data if has different typeId appointment type id in the context.
   * This can be possible when user use back and forth browser button to navigate between steps */ useBookAppointmentTypeWithUrlParam();
    React.useEffect(()=>{
        if (store && !queryParams.storeId) {
            setStore(null);
        }
        if (type && !queryParams.typeId) {
            setType(null);
        }
        if (timeSlot && (!queryParams.start || !queryParams.end)) {
            setTimeSlot(null);
        }
    }, [
        queryParams,
        setStore,
        setType,
        setTimeSlot,
        store,
        type,
        timeSlot
    ]);
    React.useEffect(()=>{
        const dataLayerEvent = bookAppointmentWhereStepScreenEvent();
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    return /*#__PURE__*/ React.createElement(AppointmentLocation$1, swcHelpers.extends({}, props));
};
var AppointmentLocation = AppointmentLocationContainer;

export { AppointmentLocation as default };
//# sourceMappingURL=AppointmentLocationContainer.js.map
